export default __webpack_public_path__ + "static/media/CLA.ca1e2ca0.svg";